<template>
  <div class="w-full xl:w-full flex flex-col space-y-11">
<!--    <div class="relative">-->
<!--      <FormInput-->
<!--        v-model.trim="person"-->
<!--        :placeholder="placeholders.person[inputState.person]"-->
<!--        :invalid="$v.person.$error"-->
<!--        @blur="inputBlurHandler('person')"-->
<!--        @focus="inputFocusHandler('person')"-->
<!--      >-->
<!--        <template #label>-->
<!--          <div>{{ $t('landing.type-full-name') }}*</div>-->
<!--        </template>-->
<!--      </FormInput>-->
<!--      <div v-if="$v.person.$error" class="absolute text-danger-50 text-xs left-5 -bottom-5 2xs:-bottom-8">-->
<!--        {{ $t('landing.error:type-full-name') }}-->
<!--      </div>-->
<!--    </div>-->
    <div class="flex space-x-4 xl:space-x-0 xl:flex-col">
      <div class="relative w-1/3 xl:w-full">
        <FormInput
          v-model.trim="lastName"
          :placeholder="placeholders.lastName[inputState.lastName]"
          :invalid="$v.lastName.$error"
          @blur="inputBlurHandler('lastName')"
          @focus="inputFocusHandler('lastName')"
        >
          <template #label>
            <div>{{ $t('landing.type-last-name') }}*</div>
          </template>
        </FormInput>
        <div v-if="$v.lastName.$error" class="absolute text-danger-50 text-xs left-5 -bottom-5 2xs:-bottom-8">
          {{ $t('landing.error:type-last-name') }}
        </div>
      </div>
      <div class="relative w-1/3 xl:w-full xl:mt-9">
        <FormInput
          v-model.trim="firstName"
          :placeholder="placeholders.firstName[inputState.firstName]"
          :invalid="$v.firstName.$error"
          @blur="inputBlurHandler('firstName')"
          @focus="inputFocusHandler('firstName')"
        >
          <template #label>
            <div>{{ $t('landing.type-first-name') }}*</div>
          </template>
        </FormInput>
        <div v-if="$v.firstName.$error" class="absolute text-danger-50 text-xs left-5 -bottom-5 2xs:-bottom-8">
          {{ $t('landing.error:type-first-name') }}
        </div>
      </div>
      <div class="relative w-1/3 xl:w-full xl:mt-9">
        <FormInput
          v-model.trim="patronymicName"
          :placeholder="placeholders.patronymicName[inputState.patronymicName]"
          :invalid="$v.patronymicName.$error"
          @blur="inputBlurHandler('patronymicName')"
          @focus="inputFocusHandler('patronymicName')"
        >
          <template #label>
            <div>{{ $t('landing.type-patronymic-name') }}</div>
          </template>
        </FormInput>
        <div v-if="$v.patronymicName.$error" class="absolute text-danger-50 text-xs left-5 -bottom-5 2xs:-bottom-8">
          {{ $t('landing.error:type-patronymic-name') }}
        </div>
      </div>
    </div>
    <div class="flex sm:flex-col sm:space-y-9 space-x-4 sm:space-x-0">
      <div class="relative w-1/2 sm:w-full">
        <FormSelect
          v-model="nationality"
          :options="nationalityOptions"
          :placeholder="`${$t('landing.citizenship')}*`"
          :invalid="$v.nationality.$error"
          @search-blur="checkData('nationality')"
        >
          <template #label>
            <div>{{ $t('landing.citizenship') }}*</div>
          </template>
        </FormSelect>
        <div v-if="$v.nationality.$error" class="absolute text-danger-50 text-xs left-5 -bottom-5">
          {{ $t('landing.error:citizenship') }}
        </div>
      </div>
      <div class="relative w-1/2 sm:w-full">
        <FormInputDate
          v-model="birthday"
          class="date-picker"
          :invalid="$v.birthday.$error"
          :max-date="maxDate"
        >
          <template #label>
            <div>{{ $t('landing.birthday')}}*</div>
          </template>
        </FormInputDate>
        <div v-if="$v.birthday.$error" class="absolute text-danger-50 text-xs left-5 -bottom-5">
          {{ $t('landing.type-birthday') }}
        </div>
      </div>
    </div>
    <div class="flex xl:flex-col gap-4 xl:gap-8">
      <div class="flex gap-4 relative w-1/2 xl:w-full">
        <FormSelect
          v-model="phoneCode"
          class="w-24"
          :options="phoneCodes"
        >
          <template #label>
            <div>{{ $t('landing.code') }}*</div>
          </template>
        </FormSelect>
        <div class="w-full relative">
          <FormInput
            v-model="phone"
            class="w-full"
            ref="phoneInput"
            :invalid="$v.phone.$error"
            :mask="getPhoneMaskWithoutCode(phoneCode)"
            :placeholder="`${$t('landing.phone-number')}*`"
            :key="phoneCode"
            :isStatic="!phoneCode"
            @blur="checkData('phone')"
            @paste="phone = $event.clipboardData.getData('text')"
          >
            <template #label>
              <div>{{ $t('landing.phone-number') }}*</div>
            </template>
          </FormInput>
          <div v-if="$v.phone.$error" class="absolute text-danger-50 text-xs left-5 -bottom-5">
            {{ $t('landing.error:phone') }}
          </div>
        </div>
      </div>
      <div class="relative w-1/2 xl:w-full">
        <FormInput
          v-model="email"
          :invalid="$v.email.$error"
          :placeholder="`${$t('landing.email')}*`"
          @blur="checkData('email')"
        >
          <template #label>
            <div>{{ $t('landing.email') }}*</div>
          </template>
        </FormInput>
        <div v-if="$v.email.$error" class="absolute text-danger-50 text-xs left-5 -bottom-5">
          {{ $t('landing.error:email') }}
        </div>
      </div>
    </div>
    <div class="relative w-full">
      <FormSelect
        v-model="communicationMethod"
        :options="communicationMethodOptions"
        :invalid="$v.communicationMethod.$error"
        :placeholder="`${$t('landing.prefered-communication-method')}*`"
        @search-blur="checkData('communicationMethod')"
      >
        <template #label>
          <div>{{ $t('landing.prefered-communication-method') }}*</div>
        </template>
      </FormSelect>
      <div v-if="$v.communicationMethod.$error" class="absolute text-danger-50 text-xs left-5 -bottom-5">
        {{ $t('landing.error:prefered-communication-method') }}
      </div>
    </div>

    <div
      v-if="$route.query.utm_source === 'promotion_bring_friend'"
      class="flex justify-center xl:w-full mt-8 mb-10 font-bold text-32px sm:text-2xl"
    >
      {{ $t('landing.recommender-data-title') }}
    </div>

    <div
      v-if="$route.query.utm_source === 'promotion_bring_friend'"
      class="flex gap-2"
    >
      <div class="relative w-1/2">
        <FormInput
          v-model.trim="friendName"
          :placeholder="$t('landing.full-name')"
          :invalid="$v.friendName.$error"
          @blur="inputBlurHandler('friendName')"
          @focus="inputFocusHandler('friendName')"
        >
          <template #label>
            <div>{{ $t('landing.full-name') }}*</div>
          </template>
        </FormInput>
        <div
          v-if="$v.friendName.$error"
          class="absolute text-danger-50 text-xs left-5 -bottom-5 2xs:-bottom-8"
        >
          {{ $t('landing.error:type-full-name') }}
        </div>
      </div>

      <div class="relative w-1/2">
        <FormInput
          v-model.trim="friendCity"
          :placeholder="$t('landing.city')"
          :invalid="$v.friendCity.$error"
          @blur="inputBlurHandler('friendCity')"
          @focus="inputFocusHandler('friendCity')"
        >
          <template #label>
            <div>{{ $t('landing.city') }}*</div>
          </template>
        </FormInput>
        <div
          v-if="$v.friendCity.$error"
          class="absolute text-danger-50 text-xs left-5 -bottom-5 2xs:-bottom-8"
        >
          {{ $t('landing.error:recommender-city') }}
        </div>
      </div>
    </div>

    <div
      v-if="$route.query.utm_source === 'promotion_bring_friend'"
      class="flex space-x-2 items-start"
    >
      <FormCheckbox
        v-model="hasWorkBefore"
      />
      <p>{{ $t('landing.has-work-in-this-company-before') }}</p>
    </div>

    <div class="relative w-full">
      <FormInput
        v-show="communicationMethod === 'VK'"
        v-model="profile"
        :invalid="$v.profile.$error"
        :placeholder="`${$t('landing.type-profile-vk-link')}*`"
        @blur="checkData('profile')"
      >
        <template #label>
          <div>{{ $t('landing.profile-vk') }}*</div>
        </template>
      </FormInput>
    </div>

    <div
      :class="{ 'order-1': $route.query.utm_source === 'promotion_bring_friend' }"
      class="flex space-x-2 items-start"
    >
      <FormCheckbox
        v-model="agreement"
        :invalid="shouldAgreement"
        @input="($event) => shouldAgreement = !$event"
      />
      <template v-if="$domain === 'ru'">
        <p
          class="text-left text-base sm:text-sm"
          :class="{ 'text-danger-50': shouldAgreement }"
          v-html="$t('landing.data-processing-and-agreement-links')"
        ></p>
      </template>
      <template v-else-if="$route.query.language === 'ru'">
        <p
          class="text-left text-base sm:text-sm"
          :class="{ 'text-danger-50': shouldAgreement }"
          v-html="$t(dataProcessingFile)"
        ></p>
      </template>
      <template v-else>
        <p
          class="text-left text-base sm:text-sm"
          :class="{ 'text-danger-50': shouldAgreement }"
          v-html="$t('landing.data-processing-and-agreement-links')"
        ></p>
      </template>
    </div>

    <div class="flex justify-end">
      <Button
        :disabled="$v.$invalid || !agreement || isNextButtonDisabled"
        @click="debouncedSubmit" class="w-1/2"
      >
        <template v-if="!isSlowUpload">{{ $t('landing.next') }}</template>
        <Spinner v-else />
      </Button>
    </div>
  </div>
</template>
<script>

import debounce from 'lodash.debounce';
import { required, email } from 'vuelidate/lib/validators';
import FormInput from '@/components/Form/FormInput.vue';
import FormSelect from '@/components/Form/FormSelect.vue';
import FormInputDate from '@/components/Form/FormInputDate.vue';
import FormCheckbox from '@/components/Form/FormCheckbox.vue';
import Button from '@/components/UI/Button.vue';
import toast from '@/notify';
import sanitize from '@/sanitize';
import { i18n } from '@/i18n';
import phoneMaskMixin from '@/mixins/phoneMaskMixin';
import { phoneValidator } from '@/helpers/validation';
import { phoneCodes } from '@/constants/countryList';
import Spinner from '@/components/Bars/Spinner.vue';

export default {
  name: 'UserInfo',
  components: {
    Spinner,
    FormInput,
    FormSelect,
    FormInputDate,
    FormCheckbox,
    Button,
  },
  props: {
    nationalityOptions: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [phoneMaskMixin],
  data() {
    return {
      phoneCodes,
      i18n,
      phoneCode: '',
      // person: '',
      firstName: '',
      lastName: '',
      patronymicName: '',
      nationality: '',
      birthday: new Date('2000-06-01'),
      phone: '',
      email: '',
      agreement: false,
      shouldAgreement: false,
      profile: '',
      friendName: '',
      friendCity: '',
      hasWorkBefore: false,
      communicationMethod: this.$t('landing.phone'),
      communicationMethodOptions: [
        this.$t('landing.phone'),
        this.$t('landing.email'),
        'Telegram',
        'WhatsApp',
        'Viber',
        'VK',
      ],
      inputState: {
        // person: 'blur',
        firstName: 'blur',
        lastName: 'blur',
        patronymicName: 'blur',
      },
      placeholders: {
        // person: {
        //   focus: this.$t('landing.full-name-exemplicant'),
        //   blur: `${this.$t('landing.type-full-name')}*`,
        // },
        firstName: {
          focus: this.$t('landing.first-name-exemplicant'),
          blur: `${this.$t('landing.type-first-name')}*`,
        },
        lastName: {
          focus: this.$t('landing.last-name-exemplicant'),
          blur: `${this.$t('landing.type-last-name')}*`,
        },
        patronymicName: {
          focus: this.$t('landing.patronymic-name-exemplicant'),
          blur: `${this.$t('landing.type-patronymic-name')}`,
        },
      },
      isNextButtonDisabled: false,
      isSlowUpload: false,
    };
  },
  validations() {
    return this.validationRules;
  },
  mounted() {
    const storageData = JSON.parse(sessionStorage.getItem('userInfo'));
    if (storageData) {
      // this.person = storageData.person;
      this.firstName = storageData.firstName;
      this.lastName = storageData.lastName;
      this.patronymicName = storageData.patronymicName;
      this.nationality = storageData.nationality;
      this.birthday = new Date(storageData.birthday);
      this.email = storageData.email;
      this.agreement = storageData.agreement;
      this.communicationMethod = storageData.communicationMethod;

      if (storageData.phone) {
        const [phoneCode] = storageData.phone.match(/\+(.*?) /);
        this.phoneCode = phoneCode.trim();
        this.phone = storageData.phone.replace(phoneCode);
      }
    }
  },
  computed: {
    dataProcessingFile() {
      return `landing.data-processing-and-agreement-links-${this.$domain}`;
    },
    validationRules() {
      const result = {
        // person: {
        //   required,
        //   mustBeRussianStrings(value) {
        //     switch (this.$i18n.locale) {
        //       case 'ru':
        //         return /^[а-яё\s]{1,}(-)?[а-яё\s]{1,} [а-яё\s]{1,} [а-яё\s]{1,}$/i.test(value);
        //       default: return true;
        //     }
        //   },
        //   mustHaveThreeWords: (value) => value.split(' ').length === 3,
        //   symbolsTest: (value) => !/[\\|/'"`]/g.test(value),
        // },
        lastName: {
          required,
          mustBeRussian: (value) => {
            if (!value) return true;
            switch (this.$i18n.locale) {
              case 'ru':
                return /^[а-яё-]+$/i.test(value.trim());
              default:
                return true;
            }
          },
          symbolsTest: (value) => !/[\\|/'"`]/g.test(value),
        },
        firstName: {
          required,
          mustBeRussian: (value) => {
            if (!value) return true;
            switch (this.$i18n.locale) {
              case 'ru':
                return /^[а-яё-]+$/i.test(value.trim());
              default:
                return true;
            }
          },
          symbolsTest: (value) => !/[\\|/'"`]/g.test(value),
        },
        patronymicName: {
          mustBeRussian: (value) => {
            if (!value) return true;
            switch (this.$i18n.locale) {
              case 'ru':
                return /^[а-яё-]+$/i.test(value.trim());
              default:
                return true;
            }
          },
          symbolsTest: (value) => !/[\\|/'"`]/g.test(value),
        },
        profile: {
          shouldHaveValueIfCurrent: (value, v) => (v.communicationMethod === 'VK' ? !!value : true),
        },
        nationality: {
          required,
        },
        birthday: {
          required,
          belowMaxDate: (value) => {
            const currentDate = new Date();
            const currentYear = currentDate.getFullYear();
            const maxYear = currentYear - 1;
            const maxDate = currentDate.setFullYear(maxYear, 11, 31);
            return new Date(value) <= new Date(maxDate);
          },
        },
        phone: phoneValidator(this.phoneCode),
        email: {
          required,
          email,
          symbolsTest: (value) => !/[\\|/'"`]/g.test(value),
        },
        communicationMethod: {
          required,
        },
      };

      if (this.isPromotionBringFriend) {
        return {
          ...result,
          friendName: {
            required,
          },
          friendCity: {
            required,
          },
        };
      }

      return result;
    },
    maxDate() {
      const currentDate = new Date();
      const currentYear = currentDate.getFullYear();
      const maxYear = currentYear - 1;
      const maxDate = currentDate.setFullYear(maxYear, 11, 31);
      return new Date(maxDate);
    },
    isPromotionBringFriend() {
      return this.$route.query.utm_source === 'promotion_bring_friend';
    },
    formData() {
      const result = {
        // person: sanitize(this.person),
        firstName: sanitize(this.firstName),
        lastName: sanitize(this.lastName),
        patronymicName: sanitize(this.patronymicName),
        nationality: this.nationality,
        birthday: this.birthday,
        phone: `${this.phoneCode} ${this.phone}`,
        email: this.email,
        agreement: this.agreement,
        communicationMethod: this.communicationMethod,
        profile: this.profile,
        source: this.hasWorkBefore ? 'promotion_former_employees' : this.$route.query.utm_source,
      };

      if (this.isPromotionBringFriend) {
        return {
          ...result,
          friendName: sanitize(this.friendName),
          friendCity: sanitize(this.friendCity),
        };
      }

      return result;
    },
  },
  created() {
    window.addEventListener('is-next-button-disabled', this.handleUpdateSuccess);
    window.addEventListener('is-slow-upload', this.handleSlowUploading);
  },
  beforeDestroy() {
    window.removeEventListener('is-next-button-disabled', this.handleUpdateSuccess);
    window.removeEventListener('is-slow-upload', this.handleSlowUploading);
  },
  methods: {
    handleUpdateSuccess(data) {
      this.isNextButtonDisabled = data?.detail;
    },
    handleSlowUploading(data) {
      this.isSlowUpload = data?.detail;
    },
    /* eslint-disable */
    debouncedSubmit: debounce(
      function () {
        this.submitUserInfo();
      },
      1000,
    ),
    /* eslint-enable */
    submitUserInfo() {
      this.$v.$touch();
      if (!this.agreement) {
        this.shouldAgreement = true;
      }
      if (!this.$v.$invalid && this.agreement) {
        this.$emit('user-info-ready', this.formData);
      }
    },
    checkData(d) {
      this.$v[d].$touch();
      if (d === 'email') {
        const regexp = /^(?:[^:]+:\/\/)?([^.]+\.)*([^.]+)\.([^.]+)(?:$|\/)/;
        const domain = this.email.match(regexp);
        if (domain && domain[3] && !['ru', 'com'].includes(domain[3])) {
          toast.warning({
            title: this.$t('errors.maybe-error'),
            text: this.$t('errors.check-email'),
          });
        }
      }
    },
    inputFocusHandler(d) {
      this.inputState[d] = 'focus';
    },
    inputBlurHandler(d) {
      this.inputState[d] = 'blur';
      this.checkData(d);
    },
  },
  watch: {
    phoneCode() {
      this.phone = '';
    },
  },
};
</script>

<style>
.vs__selected-options {
  min-width: 50px;
}
</style>
